// Dynamic CMS shelves and old bookmarks share this semantic identity.
export const isContinueWatching = (label) =>
  ["REPLAYS", "CONTINUE_WATCHING"].includes(String(label?.type || label?.widgetType || "").toUpperCase()) ||
  ["71", "İzlemeye Devam Et", "Continue Watching"].includes(String(label?.id));

export const watchProgress = (item) => {
  const source = item?.lastContentInfo || item || {};
  const position = Number(source.lastDuration ?? source.lastduration ?? source.pauseTime ?? 0);
  const duration = Number(source.duration);
  if (!Number.isFinite(position) || !Number.isFinite(duration) || duration <= 0) return 0;
  return Math.round(Math.min(100, Math.max(0, position / duration * 100)) * 100) / 100;
};
